import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useStudyPackAccess } from "@hooks/useStudyPackAccess";

export const useHasAccess = () => {
	const {
		hasStudyPackPurchaseAccess,
		hasStudyPackContentAccess,
		isLoading: isStudyPackAccessLoading,
		isPending: isStudyPackAccessPending,
	} = useStudyPackAccess();
	const { isExamContextLoading } = useExamContext();

	return {
		hasStudyPackContentAccess,
		hasStudyPackPurchaseAccess,
		isLoading: isExamContextLoading || isStudyPackAccessLoading,
		isAccessPending: isExamContextLoading || isStudyPackAccessPending,
	};
};
